import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, Menu, X } from "lucide-react";
import { NAV_LINKS } from "../mock/mock";
import { useContact } from "../context/ContentContext";
import { Sheet, SheetContent, SheetTrigger } from "./ui/sheet";

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const CONTACT = useContact();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50">
      {/* Top bar */}
      <div className="hidden md:block bg-homi-black text-white/75 text-sm">
        <div className="max-w-7xl mx-auto px-6 h-11 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-2 hover:text-homi-gold transition-colors">
              <Phone className="w-4 h-4 text-homi-gold" /> {CONTACT.phone}
            </a>
            <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 hover:text-homi-gold transition-colors">
              <Mail className="w-4 h-4 text-homi-gold" /> {CONTACT.email}
            </a>
          </div>
          <div className="text-white/55">{CONTACT.hours}</div>
        </div>
      </div>

      {/* Main nav */}
      <div className={`transition-all duration-300 ${scrolled ? "bg-white shadow-md" : "bg-white/95"}`}>
        <div className="max-w-7xl mx-auto px-6 h-[84px] flex items-center justify-between">
          <Link to="/homi" className="flex items-center">
            <img
              src={scrolled ? "/emb-mark.png" : "/emb-logo.png"}
              alt="EMB - Efficent Master Builders"
              className={`w-auto transition-all duration-300 ${scrolled ? "h-11" : "h-16"}`}
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-8">
            {NAV_LINKS.map((l) => (
              <Link key={l.path} to={l.path}
                className={`font-heading font-semibold text-[15px] transition-colors relative py-2 ${isActive(l.path) ? "text-homi-gold" : "text-homi-black hover:text-homi-gold"}`}>
                {l.label}
                {isActive(l.path) && <span className="absolute left-0 -bottom-0.5 w-full h-0.5 bg-homi-gold rounded-full" />}
              </Link>
            ))}
          </nav>

          <div className="hidden lg:block">
            <Link to="/homi/contact" className="homi-btn-shine inline-flex items-center gap-2 bg-homi-gold hover:bg-homi-goldDark text-homi-black font-heading font-bold px-6 py-3 rounded-lg transition-colors">
              Get a Free Quote
            </Link>
          </div>

          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger className="lg:hidden text-homi-black"><Menu className="w-7 h-7" /></SheetTrigger>
            <SheetContent side="right" className="w-[300px] bg-white">
              <div className="flex items-center justify-between mb-8">
                <img src="/emb-logo.png" alt="EMB" className="h-12 w-auto" />
                <button onClick={() => setOpen(false)}><X className="w-6 h-6" /></button>
              </div>
              <nav className="flex flex-col gap-1">
                {NAV_LINKS.map((l) => (
                  <Link key={l.path} to={l.path} onClick={() => setOpen(false)}
                    className={`font-heading font-semibold py-3 border-b border-gray-100 ${isActive(l.path) ? "text-homi-gold" : "text-homi-black"}`}>
                    {l.label}
                  </Link>
                ))}
              </nav>
              <Link to="/homi/contact" onClick={() => setOpen(false)}
                className="mt-6 block text-center bg-homi-gold text-homi-black font-heading font-bold px-6 py-3 rounded-lg">
                Get a Free Quote
              </Link>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
}
